import { w as e, o as t, a as r, f as i, s as n, h as a, i as o, t as s, b as l, d as c, c as d, e as h, g as u, _ as p, j as f, k as g, l as v, m, n as b, p as y, q as O, r as L, u as j, v as x, x as w } from "./sharedStyles.js";
import { jsxs as S, jsx as T, Fragment as C } from "react/jsx-runtime";
import { uniqueId as A } from "@wds/utils";
import { IconChartConfidenceLevel as k } from "@wds/icons";
import { createUseStyles as R } from "react-jss";
import { T as M, a as N, b as z } from "./TableDataCell.js";
var I = e,
  P = t,
  _ = r.f,
  D = I("unscopables"),
  G = Array.prototype;
null == G[D] && _(G, D, {
  configurable: !0,
  value: P(null)
});
var F,
  W,
  V,
  B = {},
  E = !i(function () {
    function e() {}
    return e.prototype.constructor = null, Object.getPrototypeOf(new e()) !== e.prototype;
  }),
  H = a,
  Y = o,
  U = s,
  q = E,
  Z = n("IE_PROTO"),
  J = Object,
  K = J.prototype,
  Q = q ? J.getPrototypeOf : function (e) {
    var t = U(e);
    if (H(t, Z)) return t[Z];
    var r = t.constructor;
    return Y(r) && t instanceof r ? r.prototype : t instanceof J ? K : null;
  },
  X = i,
  $ = o,
  ee = l,
  te = Q,
  re = c,
  ie = e("iterator"),
  ne = !1;
[].keys && ("next" in (V = [].keys()) ? (W = te(te(V))) !== Object.prototype && (F = W) : ne = !0);
var ae = !ee(F) || X(function () {
  var e = {};
  return F[ie].call(e) !== e;
});
ae && (F = {}), $(F[ie]) || re(F, ie, function () {
  return this;
});
var oe = {
    IteratorPrototype: F,
    BUGGY_SAFARI_ITERATORS: ne
  },
  se = r.f,
  le = a,
  ce = e("toStringTag"),
  de = function (e, t, r) {
    e && !r && (e = e.prototype), e && !le(e, ce) && se(e, ce, {
      configurable: !0,
      value: t
    });
  },
  he = oe.IteratorPrototype,
  ue = t,
  pe = d,
  fe = de,
  ge = B,
  ve = function () {
    return this;
  },
  me = o,
  be = String,
  ye = TypeError,
  Oe = h,
  Le = u,
  je = function (e) {
    if ("object" == typeof e || me(e)) return e;
    throw ye("Can't set " + be(e) + " as a prototype");
  },
  xe = Object.setPrototypeOf || ("__proto__" in {} ? function () {
    var e,
      t = !1,
      r = {};
    try {
      (e = Oe(Object.getOwnPropertyDescriptor(Object.prototype, "__proto__").set))(r, []), t = r instanceof Array;
    } catch (e) {}
    return function (r, i) {
      return Le(r), je(i), t ? e(r, i) : r.__proto__ = i, r;
    };
  }() : void 0),
  we = p,
  Se = g,
  Te = v,
  Ce = o,
  Ae = function (e, t, r, i) {
    var n = t + " Iterator";
    return e.prototype = ue(he, {
      next: pe(+!i, r)
    }), fe(e, n, !1), ge[n] = ve, e;
  },
  ke = Q,
  Re = xe,
  Me = de,
  Ne = f,
  ze = c,
  Ie = e,
  Pe = B,
  _e = oe,
  De = Te.PROPER,
  Ge = Te.CONFIGURABLE,
  Fe = _e.IteratorPrototype,
  We = _e.BUGGY_SAFARI_ITERATORS,
  Ve = Ie("iterator"),
  Be = function () {
    return this;
  },
  Ee = b,
  He = function (e) {
    G[D][e] = !0;
  },
  Ye = B,
  Ue = y,
  qe = r.f,
  Ze = function (e, t, r, i, n, a, o) {
    Ae(r, t, i);
    var s,
      l,
      c,
      d = function (e) {
        if (e === n && g) return g;
        if (!We && e in p) return p[e];
        switch (e) {
          case "keys":
          case "values":
          case "entries":
            return function () {
              return new r(this, e);
            };
        }
        return function () {
          return new r(this);
        };
      },
      h = t + " Iterator",
      u = !1,
      p = e.prototype,
      f = p[Ve] || p["@@iterator"] || n && p[n],
      g = !We && f || d(n),
      v = "Array" == t && p.entries || f;
    if (v && (s = ke(v.call(new e()))) !== Object.prototype && s.next && (ke(s) !== Fe && (Re ? Re(s, Fe) : Ce(s[Ve]) || ze(s, Ve, Be)), Me(s, h, !0)), De && "values" == n && f && "values" !== f.name && (Ge ? Ne(p, "name", "values") : (u = !0, g = function () {
      return Se(f, this);
    })), n) if (l = {
      values: d("values"),
      keys: a ? g : d("keys"),
      entries: d("entries")
    }, o) for (c in l) (We || u || !(c in p)) && ze(p, c, l[c]);else we({
      target: t,
      proto: !0,
      forced: We || u
    }, l);
    return p[Ve] !== g && ze(p, Ve, g, {
      name: n
    }), Pe[t] = g, l;
  },
  Je = m,
  Ke = Ue.set,
  Qe = Ue.getterFor("Array Iterator"),
  Xe = Ze(Array, "Array", function (e, t) {
    Ke(this, {
      type: "Array Iterator",
      target: Ee(e),
      index: 0,
      kind: t
    });
  }, function () {
    var e = Qe(this),
      t = e.target,
      r = e.kind,
      i = e.index++;
    return !t || i >= t.length ? (e.target = void 0, {
      value: void 0,
      done: !0
    }) : "keys" == r ? {
      value: i,
      done: !1
    } : "values" == r ? {
      value: t[i],
      done: !1
    } : {
      value: [i, t[i]],
      done: !1
    };
  }, "values"),
  $e = Ye.Arguments = Ye.Array;
if (He("keys"), He("values"), He("entries"), Je && "values" !== $e.name) try {
  qe($e, "name", {
    value: "values"
  });
} catch (e) {}
var et = O("span").classList,
  tt = et && et.constructor && et.constructor.prototype,
  rt = tt === Object.prototype ? void 0 : tt,
  it = L,
  nt = {
    CSSRuleList: 0,
    CSSStyleDeclaration: 0,
    CSSValueList: 0,
    ClientRectList: 0,
    DOMRectList: 0,
    DOMStringList: 0,
    DOMTokenList: 1,
    DataTransferItemList: 0,
    FileList: 0,
    HTMLAllCollection: 0,
    HTMLCollection: 0,
    HTMLFormElement: 0,
    HTMLSelectElement: 0,
    MediaList: 0,
    MimeTypeArray: 0,
    NamedNodeMap: 0,
    NodeList: 1,
    PaintRequestList: 0,
    Plugin: 0,
    PluginArray: 0,
    SVGLengthList: 0,
    SVGNumberList: 0,
    SVGPathSegList: 0,
    SVGPointList: 0,
    SVGStringList: 0,
    SVGTransformList: 0,
    SourceBufferList: 0,
    StyleSheetList: 0,
    TextTrackCueList: 0,
    TextTrackList: 0,
    TouchList: 0
  },
  at = rt,
  ot = Xe,
  st = f,
  lt = e,
  ct = lt("iterator"),
  dt = lt("toStringTag"),
  ht = ot.values,
  ut = function (e, t) {
    if (e) {
      if (e[ct] !== ht) try {
        st(e, ct, ht);
      } catch (t) {
        e[ct] = ht;
      }
      if (e[dt] || st(e, dt, t), nt[t]) for (var r in ot) if (e[r] !== ot[r]) try {
        st(e, r, ot[r]);
      } catch (t) {
        e[r] = ot[r];
      }
    }
  };
for (var pt in nt) ut(it[pt] && it[pt].prototype, pt);
ut(at, "DOMTokenList");
var ft = j,
  gt = p,
  vt = Array.isArray || function (e) {
    return "Array" == ft(e);
  },
  mt = h([].reverse),
  bt = [1, 2];
gt({
  target: "Array",
  proto: !0,
  forced: String(bt) === String(bt.reverse())
}, {
  reverse: function () {
    return vt(this) && (this.length = this.length), mt(this);
  }
});
const yt = () => S("svg", Object.assign({
    width: "10px",
    height: "10px",
    viewBox: "0 0 10 10",
    version: "1.1",
    xmlns: "http://www.w3.org/2000/svg"
  }, {
    children: [T("title", {
      children: "stat-sig-decrease"
    }), T("defs", {
      children: T("filter", Object.assign({
        id: "filter-1"
      }, {
        children: T("feColorMatrix", {
          in: "SourceGraphic",
          type: "matrix",
          values: "0 0 0 0 0.968627 0 0 0 0 0.549020 0 0 0 0 0.392157 0 0 0 1.000000 0"
        })
      }))
    }), T("g", Object.assign({
      id: "Chart-Visualizations-(WIP)",
      stroke: "none",
      strokeWidth: "1",
      fill: "none",
      fillRule: "evenodd"
    }, {
      children: T("g", Object.assign({
        id: "NPS-|-Multiple-waves-|-Table",
        transform: "translate(-647.000000, -802.000000)"
      }, {
        children: T("g", Object.assign({
          id: "Data-Viz-Card",
          transform: "translate(72.000000, 303.000000)"
        }, {
          children: T("g", Object.assign({
            id: "Table",
            transform: "translate(53.000000, 178.000000)"
          }, {
            children: T("g", Object.assign({
              id: "Group-2",
              transform: "translate(319.000000, 317.000000)"
            }, {
              children: T("g", Object.assign({
                id: "Group-4",
                transform: "translate(203.000000, 0.000000)"
              }, {
                children: T("g", Object.assign({
                  id: "stat-sig-decrease",
                  transform: "translate(0.000000, 4.000000)",
                  filter: "url(#filter-1)"
                }, {
                  children: T("g", {
                    children: T("path", {
                      d: "M9,0.414213562 C9.55228475,0.414213562 10,0.861928813 10,1.41421356 L10,9 C10,9.55228475 9.55228475,10 9,10 C8.73478351,10 8.4804296,9.89464316 8.29289322,9.70710678 L0.707106781,2.12132034 C0.316582489,1.73079605 0.316582489,1.09763107 0.707106781,0.707106781 C0.89464316,0.519570403 1.14899707,0.414213562 1.41421356,0.414213562 L9,0.414213562 Z",
                      id: "Combined-Shape",
                      fill: "#F78C64",
                      transform: "translate(5.207107, 5.207107) rotate(-270.000000) translate(-5.207107, -5.207107) "
                    })
                  })
                }))
              }))
            }))
          }))
        }))
      }))
    }))]
  })),
  Ot = () => S("svg", Object.assign({
    width: "10px",
    height: "10px",
    viewBox: "0 0 10 10",
    version: "1.1",
    xmlns: "http://www.w3.org/2000/svg"
  }, {
    children: [T("title", {
      children: "stat-sig-increase"
    }), T("g", Object.assign({
      id: "Chart-Visualizations-(WIP)",
      stroke: "none",
      strokeWidth: "1",
      fill: "none",
      fillRule: "evenodd"
    }, {
      children: T("g", Object.assign({
        id: "NPS-|-Multiple-waves-|-Table",
        transform: "translate(-835.000000, -802.000000)",
        fill: "#44CE94"
      }, {
        children: T("g", Object.assign({
          id: "Data-Viz-Card",
          transform: "translate(72.000000, 303.000000)"
        }, {
          children: T("g", Object.assign({
            id: "Table",
            transform: "translate(53.000000, 178.000000)"
          }, {
            children: T("g", Object.assign({
              id: "Group-2",
              transform: "translate(319.000000, 317.000000)"
            }, {
              children: T("g", Object.assign({
                id: "Group-5",
                transform: "translate(391.000000, 0.000000)"
              }, {
                children: T("g", Object.assign({
                  id: "Combined-Shape",
                  transform: "translate(0.000000, 4.000000)"
                }, {
                  children: T("path", {
                    d: "M8.99456787,-1.1812773e-13 C9.54685262,-1.18229183e-13 9.99456787,0.44771525 9.99456787,1 L9.99456787,8.58578644 C9.99456787,9.13807119 9.54685262,9.58578644 8.99456787,9.58578644 C8.72935138,9.58578644 8.47499747,9.4804296 8.28746109,9.29289322 L0.701674652,1.70710678 C0.311150361,1.31658249 0.311150361,0.683417511 0.701674652,0.292893219 C0.889211031,0.10535684 1.14356494,-1.16746743e-13 1.40878143,-1.1812773e-13 L8.99456787,-1.1812773e-13 Z",
                    transform: "translate(5.201675, 4.792893) rotate(-360.000000) translate(-5.201675, -4.792893) "
                  })
                }))
              }))
            }))
          }))
        }))
      }))
    }))]
  })),
  Lt = R(({
    type: e,
    spacing: t
  }) => ({
    legend: {
      display: "flex",
      flexDirection: "row",
      justifyContent: "space-around",
      maxWidth: "50%",
      fontFamily: e.fontFamily.base,
      fontSize: e.fontSize.bodySm,
      fontWeight: e.fontWeight.regular,
      color: "#6B787F",
      margin: "0 auto 20px"
    },
    icon: {
      height: t[4],
      width: t[4],
      marginRight: t[2],
      verticalAlign: "middle"
    }
  }));
function jt({
  confidenceLevelLabels: e
}) {
  const {
    legend: t,
    icon: r
  } = Lt();
  return S("div", Object.assign({
    className: t
  }, {
    children: [S("div", {
      children: [T("span", Object.assign({
        className: r
      }, {
        children: T(k, {
          title: "confidence level icon",
          size: "md"
        })
      })), T("span", Object.assign({
        style: {
          verticalAlign: "middle"
        }
      }, {
        children: e.confidenceLevel
      }))]
    }), S("div", {
      children: [T("span", Object.assign({
        className: r
      }, {
        children: T(yt, {})
      })), T("span", Object.assign({
        style: {
          verticalAlign: "middle"
        }
      }, {
        children: e.significantDecrease
      }))]
    }), S("div", {
      children: [T("span", Object.assign({
        className: r
      }, {
        children: T(Ot, {})
      })), T("span", Object.assign({
        style: {
          verticalAlign: "middle"
        }
      }, {
        children: e.significantIncrease
      }))]
    })]
  }));
}
function xt({
  label: e,
  className: t
}) {
  const r = "string" != typeof e,
    i = r ? e.name : e,
    n = r && e.totals;
  return T(M, {
    name: i,
    totals: n || void 0,
    className: t
  });
}
function wt({
  options: e,
  row: t,
  index: r
}) {
  var i, n;
  const a = (null === (i = e.fuzzyMatching) || void 0 === i ? void 0 : i.enabled) && t.fuzzyMatching ? {
      tooltip: null === (n = t.fuzzyMatching) || void 0 === n ? void 0 : n.tooltip
    } : void 0,
    o = e.functionFormat && t.function ? {
      handler: t.function,
      type: e.functionFormat,
      description: t.functionDescription
    } : void 0,
    s = a ? void 0 : t.name;
  return T(N, {
    name: t.name,
    title: s,
    index: r,
    identifier: e.rowIdentifier,
    color: t.color,
    event: o,
    fuzzyMatching: a
  });
}
function St({
  data: e,
  className: t
}) {
  const r = e.statisticalSignificanceDirection;
  return T(z, Object.assign({
    value: e.rendered || String(e.value),
    className: t
  }, {
    children: r && S("div", Object.assign({
      className: r
    }, {
      children: ["increase" === r && T(Ot, {}), "decrease" === r && T(yt, {})]
    }))
  }));
}
function Tt({
  row: e,
  reversed: t
}) {
  return S(C, {
    children: [(t ? [...e.data].reverse() : e.data).map((t, r) => {
      const i = ["data"];
      return r === e.data.length - 1 && i.push("last"), T(St, {
        data: t,
        className: i.join(" ")
      }, A("data-"));
    }), e.changeOverTimeData.map(e => {
      const t = ["change-over-time"];
      return e.value > 0 && t.push("positive"), e.value < 0 && t.push("negative"), T(St, {
        data: e,
        className: t.join(" ")
      }, A("change-over-time-"));
    })]
  });
}
const Ct = R(e => ({
  multiWaveTable: Object.assign(Object.assign({}, x.table(e)), {
    borderCollapse: "inherit",
    width: "100%",
    "& th": Object.assign(Object.assign({}, x.th(e)), {
      fontSize: e.type.fontSize.caption,
      minWidth: "52px",
      padding: "12px 12px 8px 12px",
      "&.data": {
        whiteSpace: "nowrap"
      },
      "&.data.last:not(:first-of-type)": {
        borderTop: w.border.dark,
        borderTopLeftRadius: "5px"
      },
      "&.change-over-time": {
        borderTop: w.border.dark,
        borderLeft: w.border.light,
        "&:last-of-type": {
          borderRight: w.border.dark,
          borderTopRightRadius: "5px"
        },
        "&:nth-of-type(2)": {
          borderTop: w.border.dark,
          borderLeft: w.border.dark,
          borderTopLeftRadius: "5px"
        }
      }
    }),
    "& td": Object.assign(Object.assign({}, x.td()), {
      padding: "12px 12px",
      position: "relative",
      "& .increase": {
        position: "absolute",
        top: "-1px",
        right: "2px"
      },
      "& .decrease": {
        position: "absolute",
        bottom: "-1px",
        right: "2px"
      },
      "&:first-child": {
        textAlign: "left",
        boxSizing: "border-box",
        padding: "12px 24px 12px 4px",
        maxWidth: w.sizes.dataLabel.fixedWidth,
        "& span": {
          verticalAlign: "middle"
        }
      },
      "&.data:not(.last)": {
        backgroundColor: "#F7F8FA"
      },
      "&.data.last": {
        fontWeight: e.type.fontWeight.medium
      },
      "&.change-over-time": {
        "&.positive": {
          color: "#00bf6f"
        },
        "&.negative": {
          color: "#f05b40"
        }
      },
      "&:not(:first-child)": {
        borderLeft: w.border.light
      },
      "&.change-over-time:last-of-type": {
        borderRight: w.border.dark
      },
      "&.change-over-time:nth-of-type(2)": {
        borderLeft: w.border.dark
      }
    }),
    "& td, & th": {
      borderBottom: w.border.light,
      "&.data.last:not(:first-of-type)": {
        borderLeft: w.border.dark
      }
    },
    "& tr:last-of-type": {
      "& td.data.last, & td.change-over-time": {
        borderBottom: w.border.dark
      }
    },
    "&.narrow": {
      width: "50%"
    },
    "&.medium": {
      width: "66%"
    },
    "&.col2 th:not(:first-child)": {
      width: "22.5%"
    },
    "&.col4 th:not(:first-child)": {
      width: "15%"
    },
    "&.col6 th:not(:first-child)": {
      width: "12%"
    },
    "&.col8 th:not(:first-child)": {
      width: "10%"
    },
    "&.col10 th:not(:first-child)": {
      width: "8%"
    },
    "&.col12 th:not(:first-child)": {
      width: "7%"
    },
    "&.col13 th:not(:first-child)": {
      width: "6%"
    }
  })
}));
function At({
  data: e = [{
    name: "",
    data: [{
      value: 0,
      rendered: "n/a"
    }],
    changeOverTimeData: [{
      value: 0,
      rendered: "n/a"
    }]
  }],
  options: t = {
    pivots: [],
    changeOverTimeLabels: ["YoY"],
    confidenceLevelLabels: {
      confidenceLevel: "",
      significantDecrease: "",
      significantIncrease: ""
    }
  }
}) {
  var r, i, n;
  const a = Ct(),
    o = e ? null === (i = null === (r = e[0]) || void 0 === r ? void 0 : r.data) || void 0 === i ? void 0 : i.length : 0,
    s = [a.multiWaveTable],
    l = !!(null === (n = t.columns) || void 0 === n ? void 0 : n.reversed),
    c = l ? function (e) {
      var t;
      const r = [...e];
      return [null !== (t = r.shift()) && void 0 !== t ? t : {
        name: ""
      }].concat(r.reverse());
    }(t.pivots) : t.pivots;
  return o < 3 ? s.push("narrow") : o >= 3 && o < 6 && s.push("medium"), o <= 2 ? s.push("col2") : o <= 4 ? s.push("col4") : o <= 6 ? s.push("col6") : o <= 8 ? s.push("col8") : o <= 10 ? s.push("col10") : o <= 12 ? s.push("col12") : s.push("col13"), e && e.length ? S(C, {
    children: [o > 1 && T(jt, {
      confidenceLevelLabels: null == t ? void 0 : t.confidenceLevelLabels
    }), S("table", Object.assign({
      className: s.join(" ")
    }, {
      children: [T("thead", {
        children: S("tr", {
          children: [c.map((e, r) => {
            const i = ["data"];
            return r === t.pivots.length - 1 && i.push("last"), T(xt, {
              label: e,
              className: i.join(" ")
            }, A("header-"));
          }), t.changeOverTimeLabels.map(e => T(xt, {
            label: e,
            className: "change-over-time"
          }, A("change-over-time-header-")))]
        })
      }), T("tbody", {
        children: e.map((e, r) => S("tr", {
          children: [T(wt, {
            options: t,
            row: e,
            index: r
          }), T(Tt, {
            row: e,
            reversed: l
          })]
        }, A("row-")))
      })]
    }))]
  }) : T("div", {});
}
export { At as M };